module.exports = __webpack_public_path__ + "static/media/379.a58cea66.webp";